import { createClient } from "@sanity/client";

export const sanity = createClient({
  projectId: "bprju2j3",   // from sanity.config.ts or Sanity Manage
  dataset: "production",
  apiVersion: "2024-10-01",
  useCdn: false,
});
